import WxmGalleryCard from './wxm-gallery-card/index.js';
import WxmChainEditCarousel from './wxm-chain-edit-carousel/index.js';
import WxmElTree from './wxm-el-tree/index.js';
import WxmSessionExpired from './wxm-session-expired/index.js';

let VERSION = "1.0.0";
// Install the components

const components = [
    WxmGalleryCard,
    WxmChainEditCarousel,
    WxmElTree,
    WxmSessionExpired
];

const install = function (Vue, opts = {}) {
    components.forEach(component => {
        //Vue.component(component.name, component);
        component.install(Vue);
    });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    Vue.config.silent = true;
    install(window.Vue);
}

export default {
    version: VERSION,
    install,
    WxmGalleryCard,
    WxmChainEditCarousel,
    WxmElTree,
    WxmSessionExpired
}

